import { render, staticRenderFns } from "./Ro_Materials_and_Finishes.vue?vue&type=template&id=6ef71c68&scoped=true"
import script from "./Ro_Materials_and_Finishes.vue?vue&type=script&setup=true&lang=js"
export * from "./Ro_Materials_and_Finishes.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Ro_Materials_and_Finishes.vue?vue&type=style&index=0&id=6ef71c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef71c68",
  null
  
)

export default component.exports